import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { TripData, TripEditRequest } from '../../../models';
import { PreSignedUrlResponse } from '../../../models/file.model';

export const tripOutputFileGenerationRequest = createAction(
        '[Trip File Context] output file generation request', props<{ trip: TripData }>());

export const tripOutputFilePreSignedUrlRequest = createAction(
        '[Trip File Context] output file pre-signed URL request', props<{ file: File, customerIdentifier: string }>());

export const tripOutputFilePreSignedUrlSuccess = createAction(
        '[Trip File Context] output file pre-signed URL success', props<{ preSignedUrlResponse: PreSignedUrlResponse, file: File }>());

export const tripOutputFileUploadRequest = createAction(
        '[Trip File Context] output file upload request', props<{ file: File, preSignedUrl: string }>());

export const tripOutputFileUploadSuccess = createAction(
        '[Trip File Context] output file upload success', props<{ uploadedFileUrl: string }>());

export const tripFilePreSignedUrlRequest = createAction(
        '[Trip File Context] file pre-signed URL request', props<{ file: File, customerIdentifier: string }>());

export const tripFilePreSignedUrlSuccess = createAction(
        '[Trip File Context] file pre-signed URL success', props<{ preSignedUrlResponse: PreSignedUrlResponse, file: File }>());

export const tripFilePreSignedUrlFail = createAction(
        '[Trip File Context] file pre-signed URL fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripFileUploadRequest = createAction(
        '[Trip File Context] file upload request', props<{ file: File, preSignedUrl: string }>());

export const tripFileUploadSuccess = createAction(
        '[Trip File Context] file upload success', props<{ uploadedFileUrl: string }>());

export const tripFileUploadFail = createAction(
        '[Trip File Context] file upload fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripFileEditSave = createAction(
        '[Trip File Context] file edit save', props<{ tripToEdit: TripEditRequest }>());

export const tripFileEditSaveSuccess = createAction(
        '[Trip File Context] file edit save success', props<{ editedTrip: TripData }>());

export const tripFileEditSaveFail = createAction(
        '[Trip File Context] edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripFilesDeleteRequest = createAction(
        '[Trip File Context] multiple file delete request', props<{ filesKeys: string[] }>());

export const tripFilesDeleteSuccess = createAction(
        '[Trip File Context] multiple file delete success', props<{ deletedFilesKeys: string[] }>());

export const tripFilesDeleteFail = createAction(
        '[Trip File Context] multiple file delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

